module.exports = __webpack_public_path__ + "static/media/navBg.97161379.png";